<template>
			<full-page-wrapper>

					<div class="title" slot="header">
						
						Rooms{{(this.selectedBuilding) ? " - " + this.selectedBuilding.name + " (" + this.selectedBuilding.bldgAlpha + ")" : ""}}

						<v-layout justify-space-around mt-4 px-5>

						<v-flex px-5>
				            <v-autocomplete
								dark
								@change="addFloorFilter"
				                autocomplete
								v-model="autocompleteFloorSelected"
				                clearable         
				                :items="floors"
				                label="Filter Floor">
				            </v-autocomplete>
						</v-flex>
						<v-flex px-5>
				            <v-autocomplete
								dark
								@change="addCollegeFilter"
				                autocomplete				               
				                v-model="autocompleteCollegeSelected"
				                clearable
				                :items="colleges"
				                label="Filter College">
				            </v-autocomplete>
						</v-flex>
						<v-flex px-5>
							<v-autocomplete
								dark
								@change="addDeptFilter"
				                autocomplete				               
				                v-model="autocompleteDeptSelected"
				                clearable
				                :items="depts"
				                label="Filter Dept">
				            </v-autocomplete>
				        </v-flex>						
						<v-flex px-5>
				            <v-autocomplete
								dark
								@change="addCategoryFilter"
				                autocomplete				                
				                v-model="autocompleteCategorySelected"
				                clearable         
				                style=""
				                :items="categories"
				                label="Filter Category">
				            </v-autocomplete>
						</v-flex>
						<v-flex px-5>
				            <v-autocomplete
								dark
								@change="addUseFilter"
				                autocomplete			         
				                v-model="autocompleteUseSelected"
				                clearable         
				                style=""
				                :items="useNames"
				                label="Filter Use">
				            </v-autocomplete>
						</v-flex>
						<v-checkbox class="ml-4 checkbox" dark v-model="showOccupantsPIs" :label="'Occupants, PIs, User Depts'"></v-checkbox>
						</v-layout>
					</div>
					
					<v-btn dark icon @click="exportTable" class="RTExportButton">
						<v-tooltip left><v-icon slot="activator" dark large>save_alt</v-icon>
						<span>Export to Excel</span>
						</v-tooltip>
					</v-btn>
						

						<v-data-table
								class="innertable"
								item-key="key" 
								:headers="computedHeaders" 
								:items="items" 
								:loading="loading"
								hide-actions>
								<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
								<template slot="items" slot-scope="props">
									<tr @click="roomTableClick(props.item)" :id="props.item.key" :active="props.selected">
										<td :class="{ 'text-xs-right' : header.align == 'right' }"
											class="caption rt-td" v-for="(header, index) in computedHeaders" v-bind:key="index">
											{{ getColumnData(props.item, header) }}
										</td>
									</tr>
								</template>
								<template slot="footer">                  
									<td v-for="(header, index) in computedHeaders" class="caption text-xs-right" v-bind:key="index">
										<div v-if="header.total">{{ sumCalc(header.value) }}</div>
									</td>
								</template>
						</v-data-table>
			</full-page-wrapper>
</template>


<script>
import Vuex from 'vuex'
import { mapState, mapActions, mapMutations } from 'vuex'
import FullPageWrapper from '@/components/FullPageWrapper/FullPageWrapper'
import XLSX from 'xlsx'

export default {
	name: 'RoomTable',
	components : {FullPageWrapper},

	data () {
		return {
			autocompleteFloorSelected: null,
			autocompleteDeptSelected: null,
			autocompleteCollegeSelected: null,
			autocompleteUseSelected: null,
			autocompleteCategorySelected: null,
			filters:  [ 
						{ property: 'floor', 	value: null },
						{ property: 'deptName', value: null },
						{ property: 'collegeName', value: null },
						{ property: 'categoryName', value: null },
						{ property: 'useName', value: null },
			 		],
			loading: false,
			bldgAutoSelect: null,
			pagination: {//rowsPerPage: 15
									},
			buildingNumber : "21",
			searchResults : [],
			testSwitch: false,
			showOccupantsPIs: false,
			headers : true ? [
						
						{ text: 'Number',           value: 'number',         class: 'column',        },
						{ text: 'Floor',            value: 'floor',          class: 'column',        },
						{ text: 'Occupant',         value: 'occupant',       class: 'column',        },
						{ text: 'PI',               value: 'PI',             class: 'column',        }, 
						{ text: 'College ID',       value: 'collegeID',      class: 'column',        },
						{ text: 'College Name',     value: 'collegeName',    class: 'column',        },
						{ text: 'Dept ID',          value: 'deptID',         class: 'column',        },
						{ text: 'Dept Name',        value: 'deptName',     	 class: 'column',        },
						{ text: 'User Dept',		value: 'userDept', 		 class: 'column', 		 }, 
						//{ text: 'SuperCategory',    value: 'categorySuper',  class: 'column',        },
						{ text: 'Category',         value: 'category',       class: 'column',        },
						{ text: 'Category Name',    value: 'categoryName',   class: 'column',        },
						{ text: 'Use',              value: 'use',            class: 'column',        },
						{ text: 'Use Name',         value: 'useName',        class: 'column',        },
						{ text: 'Classification',   value: 'classification', class: 'column',        },
						{ text: 'Capacity',       	value: 'capacity',     	 class: 'column',   align: 'right', total: true			},
						{ text: 'Share',             value: 'calcArea',           class: 'column',   align: 'right', total: true        },
						{ text: 'Area',             value: 'area',           class: 'column',   align: 'right', total: true        },
        			] : null,
		}
	},
	
	computed: {
		...mapState({   
										selectedBuilding: state => state.space.selectedBuilding,
										buildingRoomsFull: state => state.space.buildingRoomsFull,
										buildingRooms: state => state.space.buildingRooms,
								}),

  		items: function () { 
  			let returnitems = this.showOccupantsPIs ? this.buildingRoomsFull : this.buildingRooms

  			// Initialize a calcArea property
  			returnitems.forEach((room) => { room.calcArea = 0 })

  			// If PCT exists (rooms-full endpoint), copy it to departments so the rest of this code works.
  			returnitems.forEach((room) => { if (room.PCT) { room.departments = room.PCT }})
				
            this.filters.forEach((filter) => {

            	// For Dept, prefilter by the rmpct level of departments, then successively filter rooms by the remaining filters
            	// Push any room with assigned space for this dept into a new array
				if (filter.value && (filter.property == "deptName" || filter.property == "collegeName")) {
					let preFilteredItems = []					
					returnitems.forEach((room) => {
						room.departments.forEach((dept) => {
							if (dept.deptName == this.autocompleteDeptSelected) {
								// Same dept can be represented twice, so += them.  
								// Replace whats in the array if its found. (Deduplicates and updates)
								room.calcArea += room.area * dept.percentage/100
								let foundRoom = preFilteredItems.find((pfRoom) => { return pfRoom.key == room.key })
								if (foundRoom) {
									foundRoom = room
								} else {
									preFilteredItems.push(room)
								}
							}
							if (dept.collegeName == this.autocompleteCollegeSelected) {
								// College could have several departments, so += them.  
								// Replace whats in the array if its found. (Deduplicates and updates)
								room.calcArea += room.area * dept.percentage/100
								let foundRoom = preFilteredItems.find((pfRoom) => { return pfRoom.key == room.key })
								if (foundRoom) {
									foundRoom = room
								} else {
									preFilteredItems.push(room)
								}
							}
						})
					})

	                // Replace returnitems with the preFiltered Array
	                returnitems = preFilteredItems
				}



				// Successive Filtering for each remaining filterterm.
                if (filter.value && filter.property != "deptName" && filter.property != "collegeName") {
                	returnitems = returnitems.filter((item) => item[`${filter.property}`] == filter.value )
                }
            })

  			return returnitems
  		},

  		computedHeaders () {
  			let returnHeaders = JSON.parse(JSON.stringify(this.headers)) // Fresh Deep Copy not using a pointer
	      	
  			// Remove these headers if checkbox for this not selected
	      	if(!this.showOccupantsPIs){
	        	returnHeaders = returnHeaders.filter(header => header.text !== "Occupant" && header.text !== "PI" && header.text !== "User Dept")
	      	}

	      	// Remove calcArea if not selecting College or Dept
	      	if(!this.autocompleteDeptSelected && !this.autocompleteCollegeSelected ){
	        	returnHeaders = returnHeaders.filter(header => header.text !== "Share")
	      	}	      

	      	// Dont remember why this last filter is needed
	      	return returnHeaders.filter(header => header.text !== "")
	    },

  		depts: function () {
  			let returnitems = []
  			this.items.forEach((room) => {  				
  				room.departments.forEach((dept) => { 
  					returnitems.push(dept.deptName) 
  				} )
  			})

  			//const items = this.items.map((room) => { return room.departments.map((dept) => dept.deptName) })
  			//const items = this.items.map((room) => { return room.deptName })
  			return returnitems.filter((item) => item != null).sort()
  		},
  		colleges: function () {
  			const items = this.items.map((room) => { if (room.collegeName) { return room.collegeName}})
  			return items.filter((item) => item != null).sort()
  		},
  		floors: function () {
  			const items = this.items.map((room) => { if (room.floor) { return room.floor}})
  			return items.filter((item) => item != null).sort()
  		},
  		categories: function () {
  			const items = this.items.map((room) => { if (room.categoryName) { return room.categoryName}})
  			return items.filter((item) => item != null).sort()
  		},
  		useNames: function () {
  			const items = this.items.map((room) => { if (room.useName) { return room.useName}})
  			return items.filter((item) => item != null).sort()
  		},
		
	},

	watch: {

		selectedBuilding (val) {
			this.filters.forEach((filter) => { filter.value = null})
			this.showOccupantsPIs=false
			//Clear autocomplete filter selection boxes on building change
			this.autocompleteUseSelected = null
			this.autocompleteFloorSelected = null
			this.autocompleteCollegeSelected = null
			this.autocompleteDeptSelected = null
			this.autocompleteCategorySelected = null
		},

     	showOccupantsPIs (val) { 
     		if (val && this.buildingRoomsFull.length==0 ) { 
				this.loading=true 
				this.fetchBuildingRoomsFull(this.selectedBuilding.bldgAlpha).then((data) => { 
					this.loading=false 
				})
			} 
     	},

     	buildingRooms (val) { 
     		if (val.length==0) { this.loading=true } else { this.loading=false }
     	},
    },

	methods : {
		...mapMutations([   'setSearchResults',
							'setSearchTitle',
							'setSearchSubtitle',
							'setSearchSort',
							'setSelectedRoom',
							'setSuspendRouting',
							'setRoomNoRoute',
							'setFullRoomNoRoute',
					]),
		
		...mapActions(['fetchBuildingRoomsFull', 'selectBuilding','fetchFullRoom']),

		roomTableClick: async function (item) {
			// Get the contentSidebar started with room data
			this.setRoomNoRoute(item)
			// Follow it up with the full room data needed for full function
			let fullRoom = await this.fetchFullRoom({bldgAlpha: this.selectedBuilding.bldgAlpha, number: item.number, noSet: true})
			this.setFullRoomNoRoute(fullRoom)			
		},

		sumCalc: function (columnName) {
			let sum = 0;        
			this.items && this.items.map((room) => { sum += room[columnName] })
			return sum.toLocaleString(undefined, { maximumFractionDigits: 0 })
		},

		getColumnData: function (item, header) {
			if (header.value == "PI") {
				let PIs = []

					item.PCT.map((pct) => {
						pct.PI.map((PI) => {
							PIs.push(PI.name)
						}) 						
					})
				return PIs.join(", ") 
			
			} else if (header.value == "occupant") {
				let occupants = []

					item.PCT.map((pct) => {
						pct.occupant.map((occupant) => {
							occupants.push(occupant.name)
						}) 						
					})
				return occupants.join(", ") 

			} else if (header.value == "userDept") {
				let userDepts = []
					item.PCT && item.PCT.map((pct) => {
						pct.userDeptID && userDepts.push(pct.userDeptID + "-" + pct.userDeptName)
					})
				return userDepts.join(", ")
			
			} else {
				if ( header.align == "right") {
					return item[header.value] ? item[header.value].toLocaleString(undefined, { maximumFractionDigits: 0 }) : item[header.value]
				} else {
					return item[header.value]
				}
			}
		},

		addDeptFilter: function (value) {
			this.addFilter("deptName", value)
		},

		addCollegeFilter: function (value) {
			this.addFilter("collegeName", value)			
		},

		addCategoryFilter: function (value) {
			this.addFilter("categoryName", value)			
		},

		addFloorFilter: function (value) {
			this.addFilter("floor", value)			
		},

		addUseFilter: function (value) {
			this.addFilter("useName", value)			
		},

		addFilter: function (property, value) {
			if (property == "deptName") {				
				const index = this.filters.findIndex(filter => filter.property=="collegeName")
				this.filters[index].value = null
				this.autocompleteCollegeSelected = null 
			}

			if (property == "collegeName") {				
				const index = this.filters.findIndex(filter => filter.property=="deptName")
				this.filters[index].value = null
				this.autocompleteDeptSelected = null 
			}

			const index = this.filters.findIndex(filter => filter.property==property)
			this.filters[index].value = value
			console.log(this.filters)
		},

		getFilterText: function() {
			let filterText = ""

			let test = this.filters[this.filters.findIndex(filter => filter.property=="floor")].value
			filterText += test ? "Floor = '" + test + "', " : "" 
			test = this.filters[this.filters.findIndex(filter => filter.property=="deptName")].value
			filterText += test ? "Dept = '" + test + "', " : ""
			test = this.filters[this.filters.findIndex(filter => filter.property=="collegeName")].value
			filterText += test ? "College = '" + test + "', " : ""
			test = this.filters[this.filters.findIndex(filter => filter.property=="categoryName")].value
			filterText += test ? "Category = '" + test + "', " : ""
			test = this.filters[this.filters.findIndex(filter => filter.property=="useName")].value
			filterText += test ? "Use = '" + test + "', " : ""
			if (filterText != "") {
				filterText = "Filters : " + filterText.slice(0, -2)
			}

			return filterText
		},

		exportTable: function () {
	      	// Create workbook
	      	const wb = XLSX.utils.book_new() 

	      	console.log("AreaSum: ", this.sumCalc('area'))

	      	// Create worksheet, and add info
	      	let ws = XLSX.utils.aoa_to_sheet([
						[`${this.selectedBuilding.bldgAlpha} - ${this.selectedBuilding.name}`],
						["Area", this.sumCalc('area')],
						[this.getFilterText()]
					])

	      	let roomData = this.items.map((room) => {
				
				if (this.showOccupantsPIs) {
					let PIs = []
					let occupants = []
					let shareIDs = []
					let shareNames = []

					room.PCT.map((pct) => {
						pct.PI.map((PI) => {
							PIs.push(PI.name)
						}) 						
					})

					room.PCT.map((pct) => {
						pct.occupant.map((occupant) => {
							occupants.push(occupant.name)
						}) 						
					})

					room.PCT.map((pct) => {
						shareIDs.push(pct.userDeptID)
						shareNames.push(pct.userDeptName)
					})

					return 	{	Building: room.bldgAlpha,
			  						Name: room.bldgName,
			  						Floor: room.floor,
			  						Room: room.number,
			  						College: `${room.collegeName} (${room.collegeID})`,
			  						Dept: `${room.deptName} (${room.deptID})`,
			  						UserDept : shareIDs.join(", "),
			  						UserDeptNames: shareNames.join(", "),
			  						Classification: room.classification,
			  						Category: room.category,
			  						CatName: room.categoryName,
			  						Type: room.type,
			  						TypeName: room.typeName,
			  						Use: room.use,
			  						UseName: room.useName,
			  						Capacity: room.capacity,
			  						Area: room.area, 
			  						Occupants: occupants.join(", "),
			  						PIs: PIs.join(", "),
			  						
		  					}
				} else {

      				return 	{	Building: room.bldgAlpha,
			  						Name: room.bldgName,
			  						Floor: room.floor,
			  						Room: room.number,
			  						College: `${room.collegeName} (${room.collegeID})`,
			  						Dept: `${room.deptName} (${room.deptID})`,
			  						Classification: room.classification,
			  						Category: room.category,
			  						CatName: room.categoryName,
			  						Type: room.type,
			  						TypeName: room.typeName,
			  						Use: room.use,
			  						UseName: room.useName,
			  						Capacity: room.capacity,
			  						Area: room.area, 

		  					}
		  		}
	      	})

	      	
	      	XLSX.utils.sheet_add_json(ws, roomData, {origin:"A5"})

			// Column Widths
			var wscols = [
				    {wch:10},
				    {wch:10},
				    {wch:10},
				    {wch:10},
				    {wch:30},
				    {wch:30},
				    {wch:20},
				    {wch:10},
				    {wch:30},
				    {wch:10},
				    {wch:30},
				    {wch:10},
				    {wch:30},
				    {wch:10},
				    {wch:30},
				    {wch:30},
				];

			ws['!cols'] = wscols;

			
			//ws['!ref'] = XLSX.utils.encode_range(range)

	      
	      	// add Worksheet to Workbook
	            XLSX.utils.book_append_sheet(wb, ws, `Room Table for ${this.selectedBuilding.bldgAlpha}`)

	        // 

	      	// export Excel file
	      	XLSX.writeFile(wb, `RoomTable ${this.selectedBuilding.bldgAlpha}.xlsx`) // name of the file is 'book.xlsx'   

	    },
	},
}

</script>


<style>

.innertable {
		height: 70vh;
		overflow-y: auto;
}

/* this technique gets deeply nested th td selectors */
.innertable th { padding-left: 20px !important; }
.innertable td { padding-left: 25px !important; }
.innertable .v-table__overflow { 
	overflow-x: unset !important;
	overflow-y: unset !important;
 }

 .innertable .table {
 	padding-left: 30px;
 	border-radius: 0px;
 }

 .RTExportButton {
 	position: absolute !important;
 	top: 60px;
 	right: 35px;
 }

 .checkbox {
 	position: absolute !important;
 	top: 60px;
 	right: 115px;
 }

</style>



// WEBPACK FOOTER //
// src/components/RoomTable.vue